<template>
  <footer class="footer footer_main">
    <Menu class="nav_footer footer__menu" transitionName="none" nameMenu="footer" />
    <div class="footer__socials socials socials_footer">
      <ul class="socials__list">
        <li class="socials__item">
          <a :href="$t('base.facebook.link')" class="socials__link" target="_blank">{{ $t('base.facebook.text') }}</a>
        </li>
        <li class="socials__item">
          <a :href="$t('base.telegram.link')" class="socials__link" target="_blank">{{ $t('base.telegram.text') }}</a>
        </li>
      </ul>
    </div>
    <div class="footer__creator">
      <span>{{ $t('mainPage.footer.creator.data-start') }}—<img src="../../static/img/svg/infinity.svg" alt=""></span>
      <span>{{ $t('mainPage.footer.creator.name') }}</span>
    </div>
    <div class="footer__designed">{{ $t('mainPage.footer.designed.text') }} <a :href="$t('mainPage.footer.designed.href')">{{ $t('mainPage.footer.designed.name') }}.</a></div>
  </footer>
</template>

<script>
import Menu from '@/components/Nav/Nav'
export default {
  name: 'Footer',
  components: {
    Menu
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue